import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
Vue.use(Vuex)

// Vue.use(axios)

let dt = new Date()

export default {
  state: {
    auth: { token: null },
    settings: {
      isAuthed: false,
      companyName: null,
      firstName: null,
      lastName: null,
      avatarURI: null,
      planName: null,
      planexpirydate: null,
      planCreatedDate: null,
      roles: [],
      modules: [],
      eulaAgreed: false,
      userTasks: [],
      searchFilters: { showFilters: false, auditStateId: null, assetTypeId: null, userId: null, teamId: null, assetId: null, groupId: null, auditorId: null, from: moment(dt).subtract(30, 'day').format(), to: moment(dt).endOf('month').format(), searchByDateTypeId: null },
      preferredName: '',
      primaryRole: '',
      email: '',
    },
  },
  mutations: {
    UPDATE_SETTING(state, field, value) {
      // alert(state.settings.searchFilters)
    },
    UPDATE_SEARCHBYDATETYPEID(state, value) {
      state.settings.searchFilters.searchByDateTypeId = value
    },
    UPDATE_AUDITSTATEID(state, value) {
      state.settings.searchFilters.auditStateId = value
    },
    UPDATE_SHOWFILTERS(state, value) {
      state.settings.searchFilters.showFilters = value
    },
    UPDATE_FROM(state, value) {
      state.settings.searchFilters.from = value
    },
    UPDATE_TO(state, value) {
      state.settings.searchFilters.to = value
    },
    UPDATE_USERID(state, value) {
      state.settings.searchFilters.userId = value
    },
    UPDATE_TEAMID(state, value) {
      state.settings.searchFilters.teamId = value
    },
    UPDATE_ASSETID(state, value) {
      state.settings.searchFilters.assetId = value
    },
    UPDATE_GROUPID(state, value) {
      state.settings.searchFilters.groupId = value
    },
    UPDATE_AUDITORID(state, value) {
      state.settings.searchFilters.auditorId = value
    },
    LOAD_USER_SETTINGS(state, settings) {
      state.settings = settings
    },
    SET_AUTHTOKEN (state, token) {
      state.auth.token = token
    },
    UPDATE_USER_SETTING (state, settingName, settingValue) {
      state.settings[settingName] = settingValue
    },
    UPDATE_USER_TASKS (state, tasks) {
      state.settings.userTasks = tasks
    },
    UPDATE_USER_SETTINGS (state, settings) {
      state.settings = settings
    },
    // REFRESH_USER_TASKS() {
    //   this.$http.get('/api/tasks/get_UserTasks/')
    //     .then((response) => {
    //       this.state.settings.userTasks = response.data
    //     })
    //     .catch(() => {
    //       this.$message.error('There has been an errror')
    //     })
    // },
  },
  actions: {
    refreshUserTasks (context) {
      // Have to use this._vm to access the vue instance from within Vuex STORE
      Vue.axios.get('/api/tasks/Get_UsersOpenTasks/')
        .then((response) => {
          context.commit('UPDATE_USER_TASKS', response.data)
        })
        .catch(() => {
          this.$message.error('There has been an errror')
        })
    },
    updateUserSettings (context, settings) {
      context.commit('UPDATE_USER_SETTINGS', settings)
    },
  },
  getters: {
    user: state => state.user,
    auth: state => state.auth,
  },
}
